import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject } from "rxjs";
import { debounceTime, finalize, takeUntil } from "rxjs/operators";
import { Cid10Service, IIcd } from "../cid10.service";

@Component({
    selector: "cid10-picker",
    templateUrl: "cid10-picker.component.html",
    encapsulation: ViewEncapsulation.None,
    providers: [Cid10Service]
})
export class Cid10PickerComponent implements OnInit {
    private _unsubscribeAll = new Subject();

    @Input() value: string | undefined;

    @Output() valueChange = new EventEmitter<string | undefined>();

    datasource$: Subject<IIcd[]> = new Subject();

    loading$ = new Subject<boolean>();

    filterCtrl: FormControl = new FormControl();

    selectCtrl: FormControl = new FormControl();

    constructor(private _service: Cid10Service) {

    }

    ngOnInit(): void {
        if(this.value) {
            this.loading$.next(true);
            this._service.search(this.value)
                .pipe(finalize(() => this.loading$.next(false)))
                .subscribe((result) => {
                    let value = result.filter(i => i.subCategoryId === this.value);
                    this.datasource$.next(value);
                });
        }

        this.filterCtrl.valueChanges
            .pipe(takeUntil(this._unsubscribeAll), debounceTime(200))
            .subscribe((keyword) => {
                if (!!keyword) {
                    this.loading$.next(true);
                    this._service.search(keyword)
                        .pipe(finalize(() => this.loading$.next(false)))
                        .subscribe((result) => {
                            this.datasource$.next(result);
                        });
                }
            });
    }

    onSelection(value) {
        this.valueChange.next(value);
    }
}